import { Box, Divider, Typography } from '@mui/material';
import { get, isArray } from 'lodash';
import React, { FC } from 'react';
import DownloadFileFromComponent from 'src/components/ui-component/form-component/form-fields/fields/DownloadFileFromComponent';
import MarkdownRenderer from 'src/components/ui-component/markdown-renderer/MarkdownRenderer';
import { useApplication } from 'src/context/ApplicationContext';
import { FOERDERPROGRAMM_DATEIEN_JE_ANTRAG_PATHS } from 'src/lib/constants/componentsPath';
import { ANTRAG_TYP, ART_DES_ANTRAGS } from 'src/lib/constants/constant';

// import Schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const AllgemeinDateienGlobal: FC<{}> = () => {
	const { application } = useApplication();

	// Daten für AllgemeinDateien
	const allgemeinInhalt = get(
		application,
		P.Foerderprogramm.schema.attributes.Foerderrichtlinie.schema.attributes.Antrag_Allgemeine_Downloads_Inhalt.path,
		'',
	);
	const allgemeineDateien = get(
		application,
		P.Foerderprogramm.schema.attributes.Foerderrichtlinie.schema.attributes.Antrag_Allgemeine_Downloads_Dateien.path,
		[],
	);

	// Prüfen ob mindestens ein Element ein Titel hat
	const hasAllgemeinTitel = isArray(allgemeineDateien) && allgemeineDateien.some((item: any) => item?.Titel);

	// Daten für ProgrammSpezifischDateien
	const antragsTyp = get(application, P.Allgemein_Typ.path, '');
	const foerderprogramm = get(application, P.Foerderprogramm.path, {});
	const artDesAntrags = get(application, P.Allgemein_Art_Des_Antrags.path, '');
	const isFormantrag = artDesAntrags === ART_DES_ANTRAGS.Formantrag;
	// Pfade für programm spezifische Dateien basierend auf AntragsTyp
	const paths =
		antragsTyp === ANTRAG_TYP.Skizze ? FOERDERPROGRAMM_DATEIEN_JE_ANTRAG_PATHS.Skizze
		: isFormantrag ? FOERDERPROGRAMM_DATEIEN_JE_ANTRAG_PATHS.Formantrag
		: FOERDERPROGRAMM_DATEIEN_JE_ANTRAG_PATHS.Antrag;

	const programmSpezifischInhalt = get(foerderprogramm, paths.Inhalt, '');
	const programmSpezifischDateien = get(foerderprogramm, paths.DateienBlock, '');

	// Prüfen ob mindestens ein Element ein Titel hat
	const hasProgrammSpezifischTitel = isArray(programmSpezifischDateien) && programmSpezifischDateien.some((item: any) => item?.Titel);

	const showDivider = hasAllgemeinTitel && hasProgrammSpezifischTitel;

	return (
		<>
			{/**Aus Förderprogramm */}
			<ProgrammSpezifischDateien
				programmSpezifischInhalt={programmSpezifischInhalt}
				programmSpezifischDateien={programmSpezifischDateien}
				hasTitel={hasProgrammSpezifischTitel}
			/>
			{/** Divider nur wenn beide etwas haben */}
			{showDivider && <Divider sx={{ borderColor: '#000', mt: '2rem' }} />}
			{/** Aus Förderrichtlinie */}
			<AllgemeinDateien allgemeinInhalt={allgemeinInhalt} allgemeineDateien={allgemeineDateien} hasTitel={hasAllgemeinTitel} />
		</>
	);
};

export default AllgemeinDateienGlobal;

const AllgemeinDateien: FC<{ allgemeinInhalt: string; allgemeineDateien: any[]; hasTitel: boolean }> = ({
	allgemeinInhalt,
	allgemeineDateien,
	hasTitel,
}) => {
	if (hasTitel) {
		return (
			<>
				<Box sx={{ mt: '1rem' }}>
					<Typography variant='h3' component={'h3'}>
						Allgemeine Downloads
					</Typography>
					<MarkdownRenderer markdown={allgemeinInhalt} />
					<DownloadFileFromComponent component={allgemeineDateien} filePathInComponent='Datei' />
				</Box>
			</>
		);
	}

	return <></>;
};

const ProgrammSpezifischDateien: FC<{ programmSpezifischInhalt: string; programmSpezifischDateien: any[]; hasTitel: boolean }> = ({
	programmSpezifischInhalt,
	programmSpezifischDateien,
	hasTitel,
}) => {
	if (hasTitel || programmSpezifischInhalt) {
		return (
			<>
				<Box sx={{ mt: '1rem' }}>
					<Typography variant='h3' component={'h3'}>
						Downloads
					</Typography>
					<MarkdownRenderer markdown={programmSpezifischInhalt} />
					<DownloadFileFromComponent component={programmSpezifischDateien} filePathInComponent='Datei' />
				</Box>
			</>
		);
	}

	return <></>;
};
